import { atom } from 'jotai';
import { IUserDetail, IUserUnavailableDetail } from '../../models';
import { pendingQueue } from 'shared/utils/pending-queue';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type TUserDetailStore = { [key: string]: PromiseOrValue<IUserDetail | IUserUnavailableDetail> | undefined };

export const $UserDetailStore = atom<TUserDetailStore>({});

export const $UserDetail = safeAtomFamily((userId: string) => {
  const a = atom<
    PromiseOrValue<IUserDetail | IUserUnavailableDetail>,
    [PromiseOrValue<IUserDetail | IUserUnavailableDetail>],
    void
  >(
    (get) => {
      const data = get($UserDetailStore)[userId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise<void>((resolve) => pendingQueue.push(() => resolve()));
      }
      return data;
    },
    (get, set, userDetail) => {
      const old = get($UserDetailStore);
      set($UserDetailStore, { ...old, [userId]: userDetail });
    },
  );

  a.debugLabel = `$UserDetail+${encodeURIComponent(userId)}`;

  return a;
});
